<template>
  <div class="analyse">
    <div class="userinfo">
      <div class="brand_box">测评报告</div>
      <div class="tit">{{ name }}</div>
      <!-- <div class="desc">{{ name }}</div> -->
      <div class="desc">
        <span v-show="userInfo.realName">{{ userInfo.realName }}</span>
        <span v-show="!userInfo.realName">{{ userInfo.userName }}</span>
        <!-- <span class="r">用时：{{ spendTime | format }}</span> -->
        <div>{{ finishTime | stringOut }}</div>
      </div>
    </div>
    <div class="content">
      <div class="box">
        <div class="cell whole">
          <van-cell title="整体概览">
            <template slot="label">
              <div class="top">
                <van-row type="flex" justify="space-around" align="center">
                  <van-col span="7">
                    <div class="circle" v-for="(item, index) in whole.difficulties" :key="index">
                      <van-circle
                        v-model="currentRate"
                        layer-color="#DCDFE6"
                        :rate="item.score"
                        :speed="50"
                        color="#75eece"
                        :text="item.score"
                        :stroke-width="120"
                        :size="50"
                        v-if="item.key == 'easy'"
                      />
                      <van-circle
                        v-model="currentRate"
                        layer-color="#DCDFE6"
                        :rate="item.score"
                        :speed="50"
                        color="#69b8fe"
                        :text="item.score"
                        :stroke-width="120"
                        :size="50"
                        v-if="item.key == 'medium'"
                      />
                      <van-circle
                        v-model="currentRate"
                        layer-color="#DCDFE6"
                        :rate="item.score"
                        :speed="50"
                        color="#ffbe59"
                        :text="item.score"
                        :stroke-width="120"
                        :size="50"
                        v-if="item.key == 'hard'"
                      />
                      <div class="tit">{{ item.name }}题</div>
                    </div>
                  </van-col>
                  <van-col span="17">
                    <div class="circle big">
                      <van-circle
                        v-model="currentRate"
                        layer-color="#DCDFE6"
                        :rate="whole.score"
                        :speed="50"
                        :color="gradientColor"
                        :text="whole.scoreText"
                        :stroke-width="150"
                        :size="150"
                        style="margin-bottom:20px"
                      >
                        <template slot="default">
                          <div class="scoretext">
                            {{ whole.scoreText }}
                            <div class="desc">总得分</div>
                          </div>
                        </template>
                      </van-circle>

                      <div class="rinfo" :class="{ c: invalidQuestions.length == 0 }">
                        <van-row>
                          <van-col span="12">
                            <span class="kuai successbg"></span>
                            答对
                            {{ whole.questionCorrectCount }}题
                          </van-col>
                          <van-col span="12">
                            <span class="kuai dangerbg"></span>
                            答错
                            {{ whole.questionErrorCount }}题
                          </van-col>
                          <van-col span="24" v-if="invalidQuestions.length > 0">
                            <span class="kuai infobg"></span>
                            无效
                            {{ whole.questionInvalidCount }}题
                            <van-icon name="question-o" @click="show = true" />
                            <span class="desc">点击?查看无效题目</span>
                          </van-col>
                        </van-row>
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </div>
              <van-divider>共测评 {{ tags.count }} 个知识点</van-divider>
              <div class="tagcount">
                <van-row>
                  <van-col span="8">
                    <p>已熟练掌握</p>
                    {{ tags.excellentCount }}个
                  </van-col>
                  <van-col span="8">
                    <p>基本熟练掌握</p>
                    {{ tags.averageCount }}个
                  </van-col>
                  <van-col span="8">
                    <p>未掌握</p>
                    {{ tags.badCount }}个
                  </van-col>
                </van-row>
              </div>
              <div class="wholeinfo">
                <div class="title">
                  您所在等级
                  <span>( 根据知识点熟练掌握情况评定 )</span>
                </div>
                <div class="progress">
                  <div class="sanyan" :style="{ left: whole.rankRate-5 + '%' }">
                    <img :src="stripHeadImg" />
                  </div>
                  <div class="strip">
                    <img :src="stripImg" />
                  </div>
                  <!-- <div class="nodebox">
                    <div
                      class="node"
                      v-for="(item, index) in whole.rankRange"
                      :key="index"
                      :style="{ left: item.rate  + '%' }"
                    >{{ item.key }}</div>
                  </div> -->
                </div>
                <div class="infobox">
                  <div class="tit">学习建议</div>
                  <div class="desc">{{ whole.propose }}</div>
                </div>
              </div>
            </template>
          </van-cell>
        </div>
      </div>
    </div>
    <div class="content2">
      <div class="box">
        <div class="cell">
          <van-cell title="知识点熟练掌握情况">
            <template slot="label">
              <van-cell title=" ">
                <template slot="label">
                  <van-row class="tags" gutter="16">
                    <van-col span="8" class="tit">熟练度</van-col>
                    <van-col span="6" class="tit">得分</van-col>
                    <van-col span="10" class="tit text_r">成就度</van-col>
                    <!-- <van-col span="6" class="tit">-</van-col> -->
                  </van-row>
                </template>
              </van-cell>

              <van-cell
                :title="item.name"
                v-for="(item, index) in tags.data"
                :key="index"
                class="taglist"
              >
                <template slot="label">
                  <van-row class="tags" gutter="16">
                    <van-col span="8">
                      <van-rate v-model="item.attainment" size="11" readonly gutter="1" />
                      <van-icon
                        name="question-o"
                        v-if="item.invalidQuestions.length"
                        @click="showTagInvalid(item.invalidQuestions)"
                      />
                    </van-col>
                    <van-col span="6">
                      <div class="strip">
                        <div
                          class="node"
                          :class="{
                            brand: item.score >= 85,
                            warning: item.score >= 60 && item.score < 85,
                            danger: item.score < 60
                          }"
                          :style="{ width: item.scoreRate + '%' }"
                        ></div>
                      </div>
                    </van-col>
                    <van-col span="10" class="text_r">
                      {{
                      item.evaluate
                      }}
                    </van-col>
                    <!-- <van-col span="6">
                  <div class="success">书本目录</div>
                    </van-col>-->
                  </van-row>
                </template>
              </van-cell>
              <div class="infobox">
                <div class="tit">可提升空间</div>
                <div class="desc">
                  <div v-if="tags.propose.weak">
                    <van-tag mark color="#F9CD3D">您还需要攻克的知识点</van-tag>
                    <p>{{ tags.propose.weak }}</p>
                  </div>
                  <div v-if="tags.propose.strengthen">
                    <van-tag mark color="#F9CD3D">您还需要强化的知识点</van-tag>
                    <p>{{ tags.propose.strengthen }}</p>
                  </div>
                </div>
              </div>
              <van-button block color="#69b8fe" class="mtop" @click="wxclose" v-if="!isShare">我要提升</van-button>
              <van-button block color="#69b8fe" class="mtop" @click="goIndex" v-if="isShare">我也要测评</van-button>
            </template>
          </van-cell>
        </div>
      </div>
      <div class="box">
        <div class="cell">
          <van-cell title="答题详情">
            <template slot="label">
              <div class="spanbox">
                <div
                  class="span"
                  v-for="(item, index) in questions"
                  :key="index"
                  :class="{
                    success: item.evaluate == 'correct',
                    danger: item.evaluate == 'error',
                    info: item.evaluate == 'invalid'
                  }"
                  @click="goUrl(item.id, index + 1)"
                >{{ item.name }}</div>
              </div>
              <div class="spandesc">
                <span class="success">答对 {{ whole.questionCorrectCount }}题</span>
                <span class="danger">答错 {{ whole.questionErrorCount }}题</span>
                <span v-if="invalidQuestions.length > 0">
                  无效 {{ whole.questionInvalidCount }}题
                  <van-icon name="question-o" @click="show = true" />
                </span>
              </div>
            </template>
          </van-cell>
        </div>
      </div>
    </div>
    <div class="content3" :style="{ height: contentShow ? 'auto' : '' }">
      <div class="mask_box" v-show="!contentShow">
        <div class="mask_text" @click="contentShow = true">
          <div class="p">查看历次分析</div>
          <img src="../../assets/more.gif" width="20" alt />
        </div>
      </div>
      <div class="box">
        <div class="cell">
          <van-cell title="综合能力">
            <template slot="label">
              <canvas id="container" height="200" style="width:96%"></canvas>
              <div v-for="(item, index) in levels" :key="index">
                <div v-if="item.tags.length > 0" class="levelstit">{{ item.name }}</div>
                <van-cell title=" " v-if="item.tags.length > 0">
                  <template slot="label">
                    <van-row class="tags" gutter="16">
                      <van-col span="8" class="tit">熟练度</van-col>
                      <van-col span="6" class="tit">得分</van-col>
                      <van-col span="10" class="tit text_r">成就度</van-col>
                      <!-- <van-col span="6" class="tit">-</van-col> -->
                    </van-row>
                  </template>
                </van-cell>
                <van-cell
                  :title="rs.name"
                  v-for="(rs, key) in item.tags"
                  :key="key"
                  class="taglist"
                >
                  <template slot="label">
                    <van-row class="tags" gutter="16">
                      <van-col span="8">
                        <van-rate v-model="rs.attainment" size="11" readonly gutter="2" />
                      </van-col>
                      <van-col span="6">
                        <div class="strip">
                          <div
                            class="node"
                            :class="{
                              brand: rs.score >= 85,
                              warning: rs.score >= 60 && rs.score < 85,
                              danger: rs.score < 60
                            }"
                            :style="{ width: rs.scoreRate + '%' }"
                          ></div>
                        </div>
                      </van-col>
                      <van-col span="10" class="text_r">
                        {{
                        rs.evaluate
                        }}
                      </van-col>
                      <!-- <van-col span="6">
                        <div class="success">书本目录</div>
                      </van-col>-->
                    </van-row>
                  </template>
                </van-cell>
              </div>
              <van-button block color="#69b8fe" class="mtop" @click="wxclose" v-if="!isShare">查看完整</van-button>
              <van-button block color="#69b8fe" class="mtop" @click="goIndex" v-if="isShare">我也要测评</van-button>
            </template>
          </van-cell>
        </div>
      </div>
    </div>
    <div class="qrcode_box">
      <div class="qrcode">
        <div class="img">
          <img src="../../assets/qrcode.png" />
        </div>
        <div class="desc">识别二维码关注源思维公众号</div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" round closeable :style="{ height: '80%' }">
      <div class="tit">无效题目</div>
      <div class="desc">答题时间在一定时间范围内（过快或过慢）视为无效</div>
      <div class="info">
        <van-cell-group>
          <van-cell :value="item.evaluate" v-for="(item, index) in invalidQuestions" :key="index">
            <template slot="title">第 {{ item.name }} 题</template>
          </van-cell>
        </van-cell-group>
      </div>
    </van-popup>
    <van-popup v-model="show1" position="bottom" round closeable :style="{ height: '80%' }">
      <div class="tit">无效题目</div>
      <div class="desc">答题时间在一定时间范围内（过快或过慢）视为无效</div>
      <div class="info">
        <van-cell-group>
          <van-cell
            :value="item.evaluate"
            v-for="(item, index) in tagInvalidQuestions"
            :key="index"
          >
            <template slot="title">第 {{ item.name }} 题</template>
          </van-cell>
        </van-cell-group>
      </div>
    </van-popup>
    <loadingPage :isShow="loading"></loadingPage>
    <div class="share" v-show="isShareTs">
      <img src="../../assets/share_tishi.png" alt />
      <div class="but">
        <van-button type="warning" @click="closeShareTs">不再提示</van-button>
        <van-button type="default" @click="isShareTs = false">我知道了</van-button>
      </div>
    </div>
    <van-overlay :show="isZixun" z-index="9999">
      <div class="wrapper" @click="isZixun = false">
        <div class="block">
          <img src="../../assets/qrcode_zx.png" alt />
          <p>识别二维码咨询</p>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import F2 from '@antv/f2'
// import wx from 'weixin-js-sdk'
import { analyseApi } from '@/api/index'
import weixinshare from '@/wxsdk/share'
import loadingPage from '../loading'
export default {
  components: {
    loadingPage
  },
  data() {
    return {
      show: false,
      show1: false,
      contentShow: false,
      loading: true,
      isShareTs: localStorage.getItem('isShareTs') ? false : true,
      isZixun: false,
      currentRate: 0,
      gradientColor: {
        '0%': '#8dc2ff',
        '100%': '#7e7fff'
      },
      name: '',
      spendTime: '',
      finishTime: '',
      whole: {
        score: 0,
        scoreText: '分',
        questionCorrectCount: 0,
        questionErrorCount: 0,
        questionInvalidCount: 0,
        difficulties: [],
        rankRange: [],
        rankRate: 0,
        propose: [],
        rank: ''
      },
      tags: {
        data: [],
        propose: {
          weak: [],
          strengthen: []
        },
        count: 0,
        averageCount: 0,
        badCount: 0,
        excellentCount: 0
      },
      questions: [],
      levels: [],
      invalidQuestions: [],
      tagInvalidQuestions: [],
      planId: 0,
      examLogId: 0,
      userInfo: {
        realName: '',
        userName: ''
      },
      isShare: false
    }
  },
  mounted() {
    this.planId = this.$route.params.sid
    this.examLogId = this.$route.params.eid
    this.isShare = this.$route.query.from ? true : false
    this.getAnalyse()

    // const linkurl = window.location.href + "!from*singlemessage";
    const linkurl = `${window.location.protocol}//${
      window.location.host
    }/assess/share/sid/${this.planId}/eid/${this.examLogId}`
    weixinshare(this.$titles, linkurl, this.$imgurls, this.$descs)
  },
  methods: {
    wxclose() {
      // wx.closeWindow()
      // location.href =
      //   ''
      // window.open(
      //   'https://bjqstkjyxgs.qiyukf.com/client?k=b30080aee8844b285ad79f08f97846e9&wp=1'
      // )
      this.isZixun = true
    },
    showTagInvalid(data) {
      this.tagInvalidQuestions = data
      this.show1 = true
    },
    startAnswer() {
      this.show = false
      this.created()
    },
    created() {
      this.timer = setInterval(this.startTimer, 1000)
    },
    startTimer() {
      this.seconds += 1
      if (this.seconds >= 60) {
        this.seconds = 0
        this.minutes = this.minutes + 1
      }
      this.timer = `${this.minutes}分${this.seconds}秒`
    },
    getAnalyse() {
      let params = {
        planID: this.planId,
        examLogId: this.examLogId
      }
      analyseApi.getAnalyse(params).then(res => {
        this.loading = false
        this.name = res.data.name
        this.spendTime = res.data.spendTime
        this.finishTime = res.data.finishTime

        this.whole.rank = res.data.rank
        this.whole.score = res.data.score
        this.userInfo = res.data.userInfo
        this.whole.scoreText = res.data.score + '分'
        this.whole.questionCorrectCount = res.data.questionCorrectCount
        this.whole.questionErrorCount = res.data.questionErrorCount
        this.whole.questionInvalidCount = res.data.questionInvalidCount
        let difficulties = res.data.difficulties.map(item => {
          item.score = item.score + '%'
          return item
        })
        this.whole.difficulties = difficulties
        this.whole.rankRange = res.data.rankRange
        this.whole.rankRate = res.data.rankRate
        this.whole.propose = res.data.propose.join('，')
        this.tags.data = res.data.tags.data
        this.tags.propose.weak = res.data.tags.propose.weak.join('；')
        this.tags.propose.strengthen = res.data.tags.propose.strengthen.join(
          '；'
        )
        this.tags.count = res.data.tags.count
        this.tags.averageCount = res.data.tags.averageCount
        this.tags.badCount = res.data.tags.badCount
        this.tags.excellentCount = res.data.tags.excellentCount
        this.questions = res.data.questions
        this.levels = res.data.levels
        this.invalidQuestions = res.data.invalidQuestions
        let data = []
        res.data.levels.forEach(item => {
          let obj = {
            year: item.name,
            sales: item.score
          }
          data.push(obj)
        })
        const chart = new F2.Chart({
          id: 'container',
          pixelRatio: window.devicePixelRatio
        })
        chart.tooltip({
          showItemMarker: false,
          onShow: function onShow(ev) {
            const items = ev.items
            items[0].name = null
            items[0].name = items[0].title
            items[0].value = items[0].value + '分'
          }
        })
        chart.source(data, {
          sales: {
            tickCount: 5,
            max: 100
          }
        })
        chart
          .interval()
          .position('year*sales')
          .color('l(90) 0:#1cc5f0 1:#45b5fb')
        chart.render()
      })
    },
    goUrl(qid, tid) {
      this.$router.push({
        name: 'result',
        params: { eid: this.examLogId, qid: qid },
        query: { tid: tid }
      })
    },
    goIndex() {
      this.$router.push({
        name: 'home'
      })
    },
    closeShareTs() {
      localStorage.setItem('isShareTs', 'OK')
      this.isShareTs = false
    }
  },
  filters: {
    format: function(value) {
      if (value > 60) {
        let i = parseInt(value / 60)
        let m = value - 60 * i
        return i + '分' + m + '秒'
      } else {
        return value + '秒'
      }
    },
    stringOut: function(value) {
      return value.substr(0, 13) + '时'
    }
  },
  computed: {
    stripImg() {
      let img = ''
      if (this.whole.rank == 'A+') {
        img = require('../../assets/strip_a+.jpg')
      } else if (this.whole.rank == 'A') {
        img = require('../../assets/strip_a.jpg')
      } else if (this.whole.rank == 'B+') {
        img = require('../../assets/strip_b+.jpg')
      } else if (this.whole.rank == 'B') {
        img = require('../../assets/strip_b.jpg')
      } else {
        img = require('../../assets/strip_c.jpg')
      }
      return img
    },
    stripHeadImg() {
      let img = ''
      if (this.whole.rank == 'A+') {
        img = require('../../assets/strip_head_a+.jpg')
      } else if (this.whole.rank == 'A') {
        img = require('../../assets/strip_head_a.jpg')
      } else if (this.whole.rank == 'B+') {
        img = require('../../assets/strip_head_b+.jpg')
      } else if (this.whole.rank == 'B') {
        img = require('../../assets/strip_head_b.jpg')
      } else {
        img = require('../../assets/strip_head_c.jpg')
      }
      return img
    }
  }
}
</script>
<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}
.analyse {
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  position: relative;
  .text_r {
    text-align: right;
  }
  .success {
    color: #44d9b1;
  }
  .successbg {
    background-color: #44d9b1;
  }
  .warning {
    color: #e6a23c;
  }
  .danger {
    color: #ff4a4a;
  }
  .dangerbg {
    background-color: #ff4a4a;
  }
  .info {
    color: #909399;
  }
  .infobg {
    background-color: #909399;
  }
  .brand {
    color: #69b8fe;
  }
  .userinfo {
    padding: 10px 0;
    > div {
      padding: 0 16px;
    }
    color: #fff;
    // background: #69b8fe;
    background-image: linear-gradient(#45b5fb, #1cc5f0);
    font-size: 12px;
    line-height: 24px;
    min-height: 180px;
    border-radius: 0 0 20px 20px;
    .brand_box {
      height: 40px;
      background: #fedb5a;
      position: absolute;
      top: 65px;
      right: 28px;
      transform: rotate(-10deg);
      font-size: 16px;
      color: #fff;
      line-height: 30px;
    }
    .tit {
      font-size: 17px;
      margin-bottom: 8px;
      .van-icon {
        float: left;
        font-size: 28px;
      }
    }
    .r {
      float: right;
    }
  }
  .content {
    width: 94%;
    position: absolute;
    left: 3%;
    top: 95px;
    z-index: 99;
    min-height: 641px;
  }
  .content2 {
    width: 94%;
    margin: 540px auto 0;
  }
  .content3 {
    height: 120px;
    overflow: hidden;
    position: relative;
    .mask_box {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 120px;
      background-image: linear-gradient(
        top,
        rgba(255, 255, 255, 0.3),
        rgba(255, 255, 255, 0.7)
      );
      z-index: 1;
      overflow: hidden;
      .mask_text {
        padding-top: 80px;
        text-align: center;
        color: #606266;
        font-size: 14px;
      }
    }
  }
  .box {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    border-radius: 15px 15px 0 0;
    .top {
      padding-top: 15px;
      .circle {
        // position: absolute;
        z-index: 100;
        text-align: center;
        /deep/ .van-circle__text {
          font-size: 12px;
        }
        .tit {
          font-size: 12px;
          color: #303133;
          margin-bottom: 10px;
        }
      }
      .circle.big {
        /deep/ .van-circle__text {
          font-size: 24px;
        }
        .scoretext {
          font-size: 24px;
          color: #303133;
          margin-top: 60px;
          .desc {
            color: #606266;
            font-size: 12px;
            line-height: 32px;
          }
        }
      }
      .rinfo {
        font-size: 13px;
        color: #606266;
        line-height: 24px;
        text-align: left;
        .kuai {
          width: 7px;
          height: 7px;
          display: inline-block;
        }
        .desc {
          font-size: 12px;
          color: #909399;
          text-align: right;
        }
      }
      .rinfo.c {
        text-align: center;
      }
    }
    .whole {
      min-height: 631px;
      .tagcount {
        text-align: center;
        font-size: 17px;
        color: #303133;
        margin-bottom: 18px;
        p {
          font-size: 12px;
          color: #909399;
          margin: 0 0 8px;
        }
        .van-col + .van-col {
          border-left: 1px dotted #ebedf0;
        }
      }
      .wholeinfo {
        .title {
          font-size: 14px;
          color: #303133;
          margin-bottom: 8px;
          span {
            font-size: 12px;
            color: #606266;
          }
        }
        .progress {
          position: relative;
          padding-top: 35px;
          .sanyan {
            position: absolute;
            top: 2px;
            width: 10%;
            img {
              width: 100%;
            }
          }
          .strip {
            padding-top: 10px;
            position: relative;
            width: 100%;
            height: auto;
            background: none;
            img {
              width: 100%;
            }
          }
          .nodebox {
            margin-top: 8px;
            position: relative;
            height: 20px;
            font-size: 13px;
            .node {
              position: absolute;
            }
          }
        }
      }
    }
    .whole.cell {
      border-radius: 15px 15px 0 0;
      .van-cell {
        border-radius: 15px 15px 0 0;
      }
    }
  }
  .levelstit {
    font-size: 15px;
    color: #303133;
    margin: 15px 0 5px;
  }
  .cell {
    background-color: #fff;
    margin-bottom: 10px;
    .infobox {
      margin-top: 22px;
      background-color: #f2f6fc;
      padding: 10px;
      .tit {
        font-size: 14px;
        color: #303133;
        margin-bottom: 8px;
      }
      .desc {
        p {
          margin: 5px 0;
          // text-indent: 1em;
        }
      }
    }
    .mtop {
      margin-top: 12px;
    }
    .taglist {
      .van-cell__title {
        color: #606266;
      }
      .tags {
        margin-top: 8px;
        .tit {
          margin-bottom: 5px;
        }
        .van-icon {
          font-size: 15px;
          margin-left: 5px;
        }
        .strip {
          width: 100%;
          height: 6px;
          background-color: #c0c4cc;
          border-radius: 6px;
          margin-top: 7px;
          position: relative;
          .node {
            position: absolute;
            height: 6px;
            border-radius: 6px;
          }
          .node.warning {
            background-color: #69b8fe;
          }
          .node.danger {
            background-color: #ff4a4a;
          }
          .node.brand {
            background-color: #75eece;
          }
        }
      }
    }
    .spanbox {
      overflow: hidden;
      .span {
        width: 30px;
        height: 30px;
        margin: 6px 5px 0;
        border-radius: 30px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        font-size: 16px;
        float: left;
      }
      .span.success {
        background-color: #44d9b1;
      }
      .span.danger {
        background-color: #ff4a4a;
      }
      .span.info {
        background-color: #c0c4cc;
      }
    }
    .spandesc {
      margin-top: 20px;
      text-align: right;
      span {
        margin: 0 6px;
      }
    }
  }
  .van-popup {
    .tit {
      text-align: center;
      height: 50px;
      line-height: 50px;
    }
    .desc {
      text-align: center;
      color: #606266;
      font-size: 12px;
      margin-bottom: 18px;
    }
    .info {
      max-height: 76%;
      overflow: auto;
    }
  }
  .qrcode_box {
    background-color: #fff;
    padding: 12px 30px;
    font-size: 12px;
    color: #606266;
    .qrcode {
      padding-top: 20px;
      text-align: center;
      img {
        width: 70%;
      }
    }
  }
  .share {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    img {
      width: 100%;
    }
    .but {
      padding-top: 30px;
      text-align: center;
      button {
        margin: 0 10px;
      }
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
      width: 150px;
      text-align: center;
      background-color: #fff;
      img {
        width: 100%;
      }
      p {
        margin: 0 0 10px;
      }
    }
  }
}
</style>
